// import PropTypes from 'prop-types';
import styles from './ImageVideoCarousel.module.scss';
import classNames from 'classnames';
import React, { useState, useEffect } from 'react';

//Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

//Components
import Icon from '../Icon';
import YouTubeVideo from '../YouTubeVideo/YouTubeVideo';
import ImageLightBox from '../ImageLightBox/ImageLightBox';

const ImageVideoCarousel = ({ title, items, showTitles = false, oneImagePerSlide = false, hideBorderBottom }) => {
    const [swiper, setSwiper] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNextSwiper = () => {
        if (swiper) {
            swiper.slideNext();
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handlePrevSwiper = () => {
        if (swiper) {
            swiper.slidePrev();
            setCurrentIndex(currentIndex - 1);
        }
    };

    const updateIndex = (Swiper) => {
        if (Swiper === null) return;
        const currentSlide = swiper?.activeIndex;
        setCurrentIndex(currentSlide);
    };

    const mobileImagesThreshold = 1;
    const desktopImagesThreshold = oneImagePerSlide ? 1 : 3;

    const swiperSettings = {
        slidesPerView: mobileImagesThreshold,
        spaceBetween: 10,

        breakpoints: {
            768: {
                slidesPerView: desktopImagesThreshold,
                spaceBetween: 24,
            },
        },
    };

    const mobileProgressStyle = {
        width: `${
            currentIndex === 0
                ? 10
                : (currentIndex /
                      Math.max(items?.length - mobileImagesThreshold, 1)) *
                  100
        }%`,
    };

    const desktopProgressStyle = {
        width: `${
            currentIndex === 0
                ? 10
                : (currentIndex /
                      Math.max(items?.length - desktopImagesThreshold, 1)) *
                  100
        }%`,
    };

    const totalItems = items?.length;
    const isNextButtonDisabledMobile =
        currentIndex >= totalItems - mobileImagesThreshold;
    const isNextButtonDisabledDesktop =
        currentIndex >= totalItems - desktopImagesThreshold;

    const classes = classNames(styles['ImageVideoCarousel'], {
        [styles['ImageVideoCarousel--HideProgressBarMobile']]: totalItems === 1,
        [styles['ImageVideoCarousel--HideProgressBarDesktop']]: totalItems < 4,
        [styles['ImageVideoCarousel--OneImagePerSlide']]: oneImagePerSlide,
        [styles['ImageVideoCarousel--HideBorder']]: hideBorderBottom
    });

    return (
        <div className={classes}>
            <div className={styles['ImageVideoCarousel__Container']}>
                <div className={styles['ImageVideoCarousel__Row']}>
                    <h2 className={styles['ImageVideoCarousel__Title']}>
                        {title}
                    </h2>
                    <div
                        className={styles['ImageVideoCarousel__SwiperButtons']}>
                        {totalItems > desktopImagesThreshold && (
                            <button
                                type={'chevron'}
                                className={classNames(
                                    styles['ImageVideoCarousel__Button'],
                                    styles[
                                        'ImageVideoCarousel__Button--Desktop'
                                    ],
                                    styles['ImageVideoCarousel__Button--Prev'],
                                    {
                                        [styles[
                                            'ImageVideoCarousel__Button--Disabled'
                                        ]]: currentIndex === 0,
                                    }
                                )}
                                disabled={currentIndex === 0}
                                onClick={() => {
                                    handlePrevSwiper();
                                }}>
                                <Icon type={'chevron'} />
                            </button>
                        )}
                        {totalItems > mobileImagesThreshold && (
                            <button
                                type={'chevron'}
                                className={classNames(
                                    styles['ImageVideoCarousel__Button'],
                                    styles[
                                        'ImageVideoCarousel__Button--Mobile'
                                    ],
                                    styles['ImageVideoCarousel__Button--Prev'],
                                    {
                                        [styles[
                                            'ImageVideoCarousel__Button--Disabled'
                                        ]]: currentIndex === 0,
                                    }
                                )}
                                disabled={currentIndex === 0}
                                onClick={() => {
                                    handlePrevSwiper();
                                }}>
                                <Icon type={'chevron'} />
                            </button>
                        )}
                        {totalItems > desktopImagesThreshold && (
                            <button
                                type={'chevron'}
                                className={classNames(
                                    styles['ImageVideoCarousel__Button'],
                                    styles[
                                        'ImageVideoCarousel__Button--Desktop'
                                    ],
                                    styles['ImageVideoCarousel__Button--Next'],
                                    {
                                        [styles[
                                            'ImageVideoCarousel__Button--Disabled'
                                        ]]: isNextButtonDisabledDesktop,
                                    }
                                )}
                                disabled={isNextButtonDisabledDesktop}
                                onClick={() => {
                                    handleNextSwiper();
                                }}>
                                <Icon type={'chevron'} />
                            </button>
                        )}
                        {totalItems > mobileImagesThreshold && (
                            <button
                                type={'chevron'}
                                className={classNames(
                                    styles['ImageVideoCarousel__Button'],
                                    styles[
                                        'ImageVideoCarousel__Button--Mobile'
                                    ],
                                    styles['ImageVideoCarousel__Button--Next'],
                                    {
                                        [styles[
                                            'ImageVideoCarousel__Button--Disabled'
                                        ]]: isNextButtonDisabledMobile,
                                    }
                                )}
                                disabled={isNextButtonDisabledMobile}
                                onClick={() => {
                                    handleNextSwiper();
                                }}>
                                <Icon type={'chevron'} />
                            </button>
                        )}
                    </div>
                </div>
                <Swiper
                    {...swiperSettings}
                    initialSlide={currentIndex}
                    onActiveIndexChange={updateIndex}
                    onSwiper={setSwiper}
                    className={styles['ImageVideoCarousel__List']}>
                    {items &&
                        items.map((item, index) => {
                            const isActive = index === currentIndex;

                            return (
                                <SwiperSlide
                                    className={
                                        styles['ImageVideoCarousel__Item']
                                    }
                                    key={index}>
                                    {item.image && (
                                        <div
                                            className={classNames(
                                                styles[
                                                    'ImageVideoCarousel__ImageWrapper'
                                                ],
                                                {
                                                    [styles['Active']]:
                                                        isActive,
                                                }
                                            )}>
                                            <ImageLightBox
                                                image={item.image}
                                                objectFit="contain"
                                                positionRelative={
                                                    oneImagePerSlide
                                                }
                                            />
                                        </div>
                                    )}

                                    {(item.id || item.videoId) && (
                                        <YouTubeVideo
                                            videoId={
                                                item.videoId
                                                    ? item.videoId
                                                    : item.id
                                            }
                                            title={
                                                showTitles
                                                    ? item.title
                                                    : undefined
                                            }
                                        />
                                    )}
                                </SwiperSlide>
                            );
                        })}
                </Swiper>

                <div
                    className={styles['ImageVideoCarousel__ProgressContainer']}>
                    {totalItems > mobileImagesThreshold && (
                        <div
                            className={classNames(
                                styles['ImageVideoCarousel__ProgressBar'],
                                styles[
                                    'ImageVideoCarousel__ProgressBar--Mobile'
                                ]
                            )}
                            style={mobileProgressStyle}
                        />
                    )}

                    {totalItems > desktopImagesThreshold && (
                        <div
                            className={classNames(
                                styles['ImageVideoCarousel__ProgressBar'],
                                styles[
                                    'ImageVideoCarousel__ProgressBar--Desktop'
                                ]
                            )}
                            style={desktopProgressStyle}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

ImageVideoCarousel.propTypes = {};

export default ImageVideoCarousel;
